const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "98%",
    align: "center",
    header: false,
    index: true,
    selection: false,
    emptyText: "暂无数据",
    column: [
      {
        label: "年份",
        prop: "statYear",
        search: true,
        clearable: true,
        searchSlot: true,
        hide: true
      },
      {
        label: "园区名称",
        prop: "parkName",
      },
      {
        label: "1月",
        prop: "month1",
      },
      {
        label: "2月",
        prop: "month2",
      },
      {
        label: "3月",
        prop: "month3",
      },
      {
        label: "4月",
        prop: "month4",
      },
      {
        label: "5月",
        prop: "month5",
      },
      {
        label: "6月",
        prop: "month6",
      },
      {
        label: "7月",
        prop: "month7",
      },
      {
        label: "8月",
        prop: "month8",
      },
      {
        label: "9月",
        prop: "month9",
      },
      {
        label: "10月",
        prop: "month10",
      },
      {
        label: "11月",
        prop: "month11",
      },
      {
        label: "12月",
        prop: "month12",
      }
    ]
  };
};

export default tableOption;
